module.exports = __webpack_public_path__ + "static/media/wi-day-haze.cd4506ad.svg";